import React from 'react';
import PropTypes from 'prop-types';
import useTheme from '../../hooks/useTheme';
import Icon from '../Icon';
import { StyledRating, StyledValue } from './styled';

const Rating = ({ rate }) => {
    const theme = useTheme();
    return (
        <StyledRating>
            <Icon
                name="star"
                fill={theme.colors.orange}
                stroke={theme.colors.orange}
                width="10"
                height="10"
            />
            <StyledValue>
                {rate === null || rate === undefined || isNaN(Number(rate)) ? '---' : Number.isInteger(rate) ? rate : parseFloat(rate).toFixed(1)}
            </StyledValue>
        </StyledRating>
    );
};

Rating.propTypes = {
    rate: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default React.memo(Rating);